const nhsNumberFormatter = (nhsNumber) =>
  `${nhsNumber.substring(0, 3)} ${nhsNumber.substring(3, 6)} ${nhsNumber.substring(6)}`;

export default nhsNumberFormatter;
